module.exports = __webpack_public_path__ + "static/img/docs1.09bac2b6.svg";